/**
 * Shared formatting utilities for the portal UI.
 */

/**
 * Format a byte count to a human-readable file size string.
 * Examples: "0 B", "512 B", "1.5 KB", "3.2 MB"
 */
// eslint-disable-next-line import/prefer-default-export
export const formatFileSize = (bytes) => {
  if (!bytes || bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  let unitIndex = 0;
  let size = bytes;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }
  return `${size % 1 === 0 ? size : size.toFixed(1)} ${units[unitIndex]}`;
};
